<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import URL from '@/views/cms/util/url'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import axios from 'axios'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    created(){
    },

    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if (clickName == "delete") {
            this.dataChanage(URL.lang.del+"/"+row.id, {id: row.id}, res => {
                if (res.code == 0) {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    this.$message.success("suc");
                } else {
                    this.$message.error(res.message);
                }
            });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage((model.id!=undefined && model.id!=null && model.id!='') ? URL.lang.edit:URL.lang.edit,model,res => {
        if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("操作成功");
          this.$refs.childTable.defaultGetData(this.queryData);
        }else{

        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        updateData:{
          cols:[

          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: 'shortName', field: 'shortName'},
               { title: 'code', field: 'code'  },
              {click:"查询",auth:"cms:lang:list"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.lang.query, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                          { title: 'displayName', field: 'displayName'},
                          { title: 'code', field: 'code' },
                          { title: 'cultureName', field: 'cultureName'},
                          { title: 'shortName', field: 'shortName'},
                          { title: 'host', field: 'host'},
                          { title: 'sort', field: 'sort'},
          ]
        }
      }
    }
  }
</script>
